// لیست کاملا آزاد
export const freeFlags = [
  { id: 3399, title: "احساس ناامیدی" },
  { id: 1865, title: "فوبیا" },
  { id: 1847, title: "احساس تنهایی" },
  { id: 1846, title: "ترس از تنهایی" },
  { id: 1427, title: "مواجهه با افکار مزاحم" },
  // { id: 1341, title: "مواجهه با شکست‌ها" },
  { id: 1324, title: "سن ازدواج" },
  { id: 1302, title: "صبوری" },
  // { id: 499, title: "ازدواج مدرن" },
  { id: 469, title: "کوچ" },
  { id: 1719, title: "تفریح" },
  { id: 460, title: "هنر" },
  { id: 1693, title: "فن بیان" },
  { id: 1374, title: "مهارت گفتگو" },
  { id: 475, title: "یادگیری زبان" },
  { id: 1696, title: "شکست مالی" },
  { id: 1695, title: "شکست شغلی" },
  { id: 2558, title: "انجام کارهای نیمه‌تمام" },
  { id: 1136, title: "بیمه" },
  { id: 2554, title: "حمایت از خانواده" },
  { id: 1861, title: "خودارضایی" },
  { id: 1860, title: "ترس از قضاوت دیگران" },
  { id: 1857, title: "مواجهه با غم و درد دیگران" },
  { id: 1383, title: "فرزندپروری زیر 3 سال" },
  { id: 1838, title: "فرزندپروری خردسال" },
  { id: 1837, title: "فرزندپروری کودک" },
  { id: 1839, title: "فرزندپروری نوجوان" },
  { id: 1758, title: "کتاب و پادکست" },
  { id: 1756, title: "فیلم و سریال" },
  { id: 1730, title: "درون‌گرا یا برون‌گرا" },
  { id: 1722, title: "بیمه عمر" },
  { id: 1721, title: "بیمه تکمیلی" },
  { id: 1720, title: "بیمه درمانی" },
  { id: 1171, title: "رانندگی" },
  { id: 1718, title: "مادری و چالش‌های چندفرزندی" },
  { id: 1430, title: "تقویت مهارت نویسندگی" },
  { id: 461, title: "تفریح - سینما، تئاتر و..." },
  { id: 1375, title: "ناراضی از بدن" },
  { id: 1340, title: "شناخت ارزش‌های زندگی" },
  { id: 1339, title: "شناخت اولویت‌های زندگی" },
  { id: 1281, title: "ترس از بیماری" },
  { id: 1233, title: "تجربه‌های دوست داشتنی" },
  { id: 1184, title: "ترس از دست دادن عزیزان" },
  { id: 1169, title: "پیدا کردن روش مقابله" },
  { id: 504, title: "فعالیت فرهنگی و مذهبی و خیریه" },
  { id: 470, title: "فعالیت داوطلبانه" },
  { id: 474, title: "یادگیری زبان" },
  { id: 3296, title: "یادگیری زبان در روانشناسی" },
  { id: 1859, title: "پیگیری و استمرار" },
  { id: 3079, title: "فرزندپروری" },
  { id: 2993, title: "کتاب و پادکست‌های روانشناسی" },
  { id: 2994, title: "فیلم و سریال در زمینه روانشناسی" },
  { id: 3376, title: "آشنایی با رویکرد شفقت درمانی (CFT)" },
  { id: 3279, title: "آشنایی با رویکرد رفتار درمانی دیالکتیکی (DBT)" },
  { id: 3074, title: "آشنایی با رویکرد شناختی رفتاری (CBT)" },
  { id: 3073, title: "آشنایی با رویکرد هیجان‌مدار (EFT)" },
  { id: 3070, title: "آشنایی با رویکرد مبتنی بر پذیرش و تعهد (ACT)" },
  {
    id: 3072,
    title: "آشنایی با رویکرد روان‌درمانی پویشی فشرده و کوتاه مدت (ISTDP)",
  },
  { id: 3071, title: "آشنایی با رویکرد طرحواره درمانی" },
  { id: 3329, title: "هوش مصنوعی در روانشناسی" },
  { id: 3069, title: "توسعه‌فردی در روانشناسی" },
  { id: 3203, title: "توسعه‌فردی همراه با مسئولیت‌های پدری در روانشناسی" },
  { id: 3204, title: "توسعه‌فردی همراه با مسئولیت‌های مادری در روانشناسی" },
  {
    id: 1504,
    title: "همزمانی تحصیل و اشتغال در روانشناسی و نقش مادری و همسری",
  },
  { id: 3078, title: "همزمانی تحصیل و اشتغال در روانشناسی و نقش پدری و همسری" },
  { id: 1855, title: "انگیزه" },
  { id: 1468, title: "چهره‌های مشهور روانشناسی جهان" },
];
